import { render, staticRenderFns } from "./favorite-list.vue?vue&type=template&id=3d75ce1c&scoped=true&"
import script from "./favorite-list.vue?vue&type=script&lang=js&"
export * from "./favorite-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d75ce1c",
  null
  
)

export default component.exports